import { getAction, postAction, putAction, deleteAction, uploadAction } from '@/api/manage'
import { axios } from '@/utils/request'

const PLUGIN_API_PREFIX = '/api/plugin/order-receive'

// 收单功能开通状态（免费可查）
export const getFeature = () => getAction(`${PLUGIN_API_PREFIX}/feature`)

// 超管开通/续期
export const openFeature = (data) => postAction(`${PLUGIN_API_PREFIX}/feature/open`, data)

// 租户收单配置
export const getConfigs = () => getAction(`${PLUGIN_API_PREFIX}/configs`)
export const saveConfigs = (data) => putAction(`${PLUGIN_API_PREFIX}/configs`, data)

// ========== P1 Task 3：合作伙伴与商品映射 ==========

// 合作伙伴
export const getPartners = (params) => getAction(`${PLUGIN_API_PREFIX}/partners`, params)
export const unbindPartner = (id) => putAction(`${PLUGIN_API_PREFIX}/partners/${id}/unbind`)
export const getPartnerArchives = (type) => getAction(`${PLUGIN_API_PREFIX}/partners/archives`, { type })
export const linkPartnerArchive = (id, supplierId) => putAction(`${PLUGIN_API_PREFIX}/partners/${id}/archive`, { supplierId })

// 商品映射
export const getItemMaps = (params) => getAction(`${PLUGIN_API_PREFIX}/item-maps`, params)
export const addItemMap = (data) => postAction(`${PLUGIN_API_PREFIX}/item-maps`, data)
export const deleteItemMap = (id) => deleteAction(`${PLUGIN_API_PREFIX}/item-maps/${id}`)
export const getMaterials = (params) => getAction(`${PLUGIN_API_PREFIX}/item-maps/materials`, params)
// 映射批量建立链路：供应商分享商品给客户 / 客户一键导入 / 客户分享单据 / 供应商一键认领
export const shareMaterials = (data) => postAction(`${PLUGIN_API_PREFIX}/item-maps/share-materials`, data)
export const importShared = () => postAction(`${PLUGIN_API_PREFIX}/item-maps/import-shared`)
export const shareBill = (data) => postAction(`${PLUGIN_API_PREFIX}/item-maps/share-bill`, data)
export const claimShared = () => postAction(`${PLUGIN_API_PREFIX}/item-maps/claim`)

// 商品别名（customerTenantId：0=通用，>0=客户专属）
export const getAliases = (params) => getAction(`${PLUGIN_API_PREFIX}/aliases`, params)
export const addAlias = (data) => postAction(`${PLUGIN_API_PREFIX}/aliases`, data)
export const updateAlias = (id, data) => putAction(`${PLUGIN_API_PREFIX}/aliases/${id}`, data)
export const deleteAlias = (id) => deleteAction(`${PLUGIN_API_PREFIX}/aliases/${id}`)
export const deleteAliases = (ids) => deleteAction(`${PLUGIN_API_PREFIX}/aliases`, { ids: ids.join(',') })
export const matchAlias = (name, customerTenantId) =>
  getAction(`${PLUGIN_API_PREFIX}/aliases/match`, { name, customerTenantId })

// ========== 商品供应商归属（惰性映射体系 P0） ==========

// 商品归属分页列表（全局视图：已设/未设；materialName/supplierId/onlyUnset 过滤）
export const getMaterialSuppliers = (params) => getAction(`${PLUGIN_API_PREFIX}/material-suppliers`, params)

// 本地供应商档案下拉（type=供应商，不要求绑定伙伴）
export const getSupplierArchives = (params) => getAction(`${PLUGIN_API_PREFIX}/material-suppliers/suppliers`, params)

// 批量设置商品归属供应商 {materialIds:[], supplierId, isDefault}（多供应商，第一个为默认）
export const setMaterialSuppliers = (data) => putAction(`${PLUGIN_API_PREFIX}/material-suppliers`, data)

// 批量清除商品归属（按商品清全部，物理删除）?materialIds=1,2,3
export const clearMaterialSuppliers = (materialIds) => deleteAction(`${PLUGIN_API_PREFIX}/material-suppliers`, { materialIds: materialIds.join(',') })

// 按行删除商品的某个供应商归属（物理删除）?ids=1,2,3
export const removeMaterialSupplierRows = (ids) => deleteAction(`${PLUGIN_API_PREFIX}/material-suppliers`, { ids: ids.join(',') })

// ========== P2 Task 4：收单中心与待分配 ==========

// 收单中心分页列表（按订单状态/来源过滤）
export const getPurchaseCenter = (params) => getAction(`${PLUGIN_API_PREFIX}/purchase-center`, params)

// 供应商关联商品弹窗数据（未审核流转 XSDD 头+明细）
export const getRelateInfo = (headId) => getAction(`${PLUGIN_API_PREFIX}/purchase-center/relate-info`, { headId })

// 供应商关联商品：换本方真实商品 + 映射/别名沉淀 {headId, items:[{itemId, materialId}]}
export const relateOrderMaterials = (data) => postAction(`${PLUGIN_API_PREFIX}/purchase-center/relate`, data)

// 待分配请购单分页列表
export const getPendingAssign = (params) => getAction(`${PLUGIN_API_PREFIX}/purchase-split/pending`, params)

// 待分配请购单人工分配供应商 {extId, qgdHeadId, items:[{itemId, supplierId}], setDefault}
export const assignPurchaseSplit = (data) => postAction(`${PLUGIN_API_PREFIX}/purchase-split/assign`, data)

// 待分配请购单标记自采（整单，不生成采购订单）
export const selfPickPurchaseSplit = (data) => postAction(`${PLUGIN_API_PREFIX}/purchase-split/self-pick`, data)

// ========== P3 Task 5：发图订单（FTDD）与 OCR 校正工作台 ==========

// 发图单分页列表（单号/客户/状态/时间筛选）
export const getImgOrders = (params) => getAction(`${PLUGIN_API_PREFIX}/img-orders`, params)

// 供应商代客户新建发图单 {customerTenantId, imageUrls:[], remark}
export const addImgOrder = (data) => postAction(`${PLUGIN_API_PREFIX}/img-orders`, data)

// 发图单详情（头信息+图片子项）
export const getImgOrder = (id) => getAction(`${PLUGIN_API_PREFIX}/img-orders/${id}`)

// 追加图片
export const appendImgOrderImages = (id, data) => postAction(`${PLUGIN_API_PREFIX}/img-orders/${id}/images`, data)

// 软删发图单
export const deleteImgOrder = (id) => deleteAction(`${PLUGIN_API_PREFIX}/img-orders/${id}`)

// 单据审核配置（billType=FTDD 发图单 / XSDD 销售订单），返回 {multiOn, flowOn}
export const getImgAuditConfig = (billType) => getAction(`${PLUGIN_API_PREFIX}/img-orders/audit-config`, { billType })

// 创建方审核发图单（'0'未审核 →'1'已审核）
export const auditImgOrder = (id) => postAction(`${PLUGIN_API_PREFIX}/img-orders/${id}/audit`)

// 提交单据至审批流程（workflow 插件：bigType=10 发图单 / 1 销售订单）
export const submitWorkflowTask = (bigType, billNo) => postAction('/api/plugin/workflow/workflowTask/add', { bigType, billNo })

// 单图OCR行与已保存校正结果
export const getImgOrderImage = (orderId, imageId) => getAction(`${PLUGIN_API_PREFIX}/img-orders/${orderId}/images/${imageId}`)

// 单图百度OCR识别
export const runImgOcr = (orderId, imageId) => postAction(`${PLUGIN_API_PREFIX}/img-orders/${orderId}/images/${imageId}/ocr`)

// 保存单图校正结果 {saveAlias, lines:[{lineIndex,text,materialId,materialName,quantity}]}
export const saveImgCorrections = (orderId, imageId, data) => putAction(`${PLUGIN_API_PREFIX}/img-orders/${orderId}/images/${imageId}/corrections`, data)

// 校正行实时解析（"识别文字"失焦自动匹配）
export const parseImgLine = (orderId, data) => postAction(`${PLUGIN_API_PREFIX}/img-orders/${orderId}/parse-line`, data)

// 全部校正完成后生成XSDD销售订单（可选 body {audit:true}：生成的订单直接置已审核）
export const generateImgOrder = (id, data) => postAction(`${PLUGIN_API_PREFIX}/img-orders/${id}/generate`, data)

// ========== P3 Task 6：扫码入库与状态跟踪 ==========

// 获取 XSDD 关联出库单（XSCK）二维码（内容+base64图，出示/打印用）
export const getScanQrCode = (headId) => getAction(`${PLUGIN_API_PREFIX}/scan/qr-code`, { headId })

// 手动触发订单状态同步（收单中心列表查询时也会自动惰性同步）
export const syncOrderStatus = () => postAction(`${PLUGIN_API_PREFIX}/status/sync`)

// H5：微信授权跳转地址
export const getH5AuthorizeUrl = (params) => getAction(`${PLUGIN_API_PREFIX}/h5/wx/authorize-url`, params)

// H5：微信授权回调（code 换登录态）
export const h5WxCallback = (params) => getAction(`${PLUGIN_API_PREFIX}/h5/wx/callback`, params)

// H5：已绑定伙伴列表
export const getH5Partners = () => getAction(`${PLUGIN_API_PREFIX}/h5/partners`)

// H5：客户订单分页列表（查询前自动惰性同步状态）
export const getH5Orders = (params) => getAction(`${PLUGIN_API_PREFIX}/h5/orders`, params)

// H5：订单详情（头信息+明细+状态时间线）
export const getH5OrderDetail = (headId) => getAction(`${PLUGIN_API_PREFIX}/h5/orders/${headId}`)

// H5：扫码入库（qrContent=二维码内容，自动生成采购入库单）
export const h5ScanInbound = (data) => postAction(`${PLUGIN_API_PREFIX}/h5/scan-inbound`, data)

// ========== P4 Task 7：配送任务与路线规划 ==========

// 配送任务分页列表（任务号/状态过滤）
export const getDeliveryTasks = (params) => getAction(`${PLUGIN_API_PREFIX}/delivery-tasks`, params)

// 创建任务选项（配送员列表/可配送出库单/上次路线方案）
export const getDeliveryTaskOptions = () => getAction(`${PLUGIN_API_PREFIX}/delivery-task-options`)

// 高德驾车路线规划（按配送点顺序输出多方案，key 未配置时 enabled=false 降级手工排序）
export const planDeliveryRoute = (data) => postAction(`${PLUGIN_API_PREFIX}/delivery-tasks/route-plan`, data)

// 创建配送任务 {courierUserId, routeMode, routeSummary, stops:[{xsckHeadId, address, longitude, latitude}]}
export const addDeliveryTask = (data) => postAction(`${PLUGIN_API_PREFIX}/delivery-tasks`, data)

// 任务详情（含配送点与 H5 分享 token）
export const getDeliveryTask = (id) => getAction(`${PLUGIN_API_PREFIX}/delivery-tasks/${id}`)

// H5：配送员免登录任务详情（secure_token 即访问凭证）
export const getH5DeliveryTask = (token) => getAction(`${PLUGIN_API_PREFIX}/h5/delivery/${token}`)

// H5：签收配送点 {xsckNo: 出库单号（可选校验）}
export const signH5DeliveryStop = (token, stopId, data) => postAction(`${PLUGIN_API_PREFIX}/h5/delivery/${token}/stops/${stopId}/sign`, data)

// ========== P5 Task 8：支付（Jeepay） ==========

// 支付商户号分页列表（超管可传 tenantId 过滤）
export const getPayMerchants = (params) => getAction(`${PLUGIN_API_PREFIX}/pay-merchants`, params)

// 新增支付商户号 {tenantId(超管必填), mchNo, remark}
export const addPayMerchant = (data) => postAction(`${PLUGIN_API_PREFIX}/pay-merchants`, data)

// 编辑支付商户号 {mchNo, status, remark}
export const updatePayMerchant = (id, data) => putAction(`${PLUGIN_API_PREFIX}/pay-merchants/${id}`, data)

// 删除支付商户号
export const deletePayMerchant = (id) => deleteAction(`${PLUGIN_API_PREFIX}/pay-merchants/${id}`)

// 支付流水分页列表（bizType/payStatus 过滤）
export const getPayOrders = (params) => getAction(`${PLUGIN_API_PREFIX}/pay-orders`, params)

// 申请退款 {payOrderNo, amount(元), reason}（仅支付成功且非年费流水；全额退款自动回退业务状态）
export const refundPayOrder = (data) => postAction(`${PLUGIN_API_PREFIX}/pay/refund`, data)

// ========== 商户进件（多渠道：微信在线进件 + 支付宝运营开通） ==========

// 查询本租户各渠道进件状态：{wx: 微信进件VO, ali: 支付宝渠道(applyStatus=3 已开通+jeepayMchNo)}
export const getMchApplyCurrent = () => getAction(`${PLUGIN_API_PREFIX}/mch-apply/current`)

// 支付宝渠道商户号手动回填（运营平台手动添加商户后填入，body: {mchNo}）
export const saveMchApplyAliMerchant = (data) => postAction(`${PLUGIN_API_PREFIX}/mch-apply/ali-merchant`, data)

// 支付宝当面付代签约提交（官方04f525三步一事务；body: {mccCode, provinceCode, cityCode, districtCode, detailAddress, aliAccount?}）
export const submitAliFaceSign = (data) => postAction(`${PLUGIN_API_PREFIX}/mch-apply/ali-face-sign`, data)

// 支付宝当面付签约状态轮询（返回 {faceStatus: 0未签约/1审核中/2待商家确认/3已签约/4驳回, confirmUrl?, rejectReason?}）
export const getAliFaceStatus = () => getAction(`${PLUGIN_API_PREFIX}/mch-apply/ali-face-status`)

// 签约/授权链接二维码（channel=WX 微信签约/账户验证（默认）；channel=ALI 支付宝授权链接，返回 {qrcodeBase64, signUrl}）
export const getMchApplySignQrcode = (channel) => getAction(`${PLUGIN_API_PREFIX}/mch-apply/sign-qrcode`, channel ? { channel } : {})

// 进件行业目录（所属行业下拉数据源：name/group/needPics/hint）
export const getMchApplyIndustries = () => getAction(`${PLUGIN_API_PREFIX}/mch-apply/industries`)

// 提交进件申请（21字段表单，驳回后可修改重提）
export const submitMchApply = (data) => postAction(`${PLUGIN_API_PREFIX}/mch-apply`, data)

// 进件图片上传（multipart：file + type，返回 {storageKey, fileName, OCR识别字段}）
export const uploadMchApplyImage = (formData) => uploadAction(`${PLUGIN_API_PREFIX}/mch-apply/image`, formData)

// 进件图片查看：新数据传 storageKey（{tenantId}/{uuid}.ext），旧数据传微信 mediaId（读历史本地副本）
export const getMchApplyImage = (keyOrId) =>
  axios.get(`${PLUGIN_API_PREFIX}/mch-apply/image`, {
    params: /^\d+\//.test(keyOrId || '') ? { key: keyOrId } : { mediaId: keyOrId },
    responseType: 'blob'
  })

// 本租户全部暂存图片（提交前任意时刻打开向导回显图片+OCR识别字段）
export const getMchApplyImages = () => getAction(`${PLUGIN_API_PREFIX}/mch-apply/images`)

// 删除暂存图片（删存储文件+暂存记录）
export const deleteMchApplyImage = (key) => deleteAction(`${PLUGIN_API_PREFIX}/mch-apply/image`, { key })

// 进件证照 OCR 识别（cardType=license/idcard_front/idcard_back/bankcard，multipart，识别结果按表单字段名返回）
export const ocrMchApply = (cardType, formData) =>
  uploadAction(`${PLUGIN_API_PREFIX}/mch-apply/ocr?cardType=${cardType}`, formData)

// 进件支行模糊搜索（联行号字典 jsh_bank_branch，返回支行全称/开户银行简称/城市/微信省市编码）
export const getMchApplyBankBranches = (params) => getAction(`${PLUGIN_API_PREFIX}/mch-apply/bank-branches`, params)

// 企业资料（合作伙伴首条，进件表单预填用）
export const getSupplierProfile = () => getAction(`${PLUGIN_API_PREFIX}/supplier-profile`)

// H5：订单支付下单（返回 payUrl 收银台/渠道跳转链接）
export const h5PayOrder = (headId, data) => postAction(`${PLUGIN_API_PREFIX}/h5/orders/${headId}/pay`, data)

// 功能年费支付下单（ERP 登录，返回 payUrl）
export const payAnnualFee = (data) => postAction(`${PLUGIN_API_PREFIX}/pay/annual-fee`, data)

// ========== 客户信用与结算方式（提示性管控） ==========

// 信用配置分页列表（customerType 形态过滤 / search 客户名搜索，行含实时欠款与提示预览）
export const getCustomerCredits = (params) => getAction(`${PLUGIN_API_PREFIX}/customer-credits`, params)

// 配置下拉数据源（type=archive/h5 客户档案 / type=partner 绑定伙伴）
export const getCustomerCreditOptions = (type) => getAction(`${PLUGIN_API_PREFIX}/customer-credits/options`, { type })

// 新增/编辑信用配置（三元组 upsert）{customerType, customerRef, settleType, holdN, settleDays, creditLimit, remark}
export const saveCustomerCredit = (data) => postAction(`${PLUGIN_API_PREFIX}/customer-credits`, data)

// 删除信用配置（物理删除，释放三元组唯一键）
export const deleteCustomerCredit = (id) => deleteAction(`${PLUGIN_API_PREFIX}/customer-credits/${id}`)

// 信用提示查询（amount 可空：不带本单金额的预览）
export const getCustomerCreditTip = (params) => getAction(`${PLUGIN_API_PREFIX}/customer-credits/tip`, params)

// ========== 商城式下单（PC 与小程序共用后端） ==========

// 商城商品分页（scope=all/supplier/partner + history 维度切换，行含 price，priceHidden=true 时不显示价格）
export const getMallMaterials = (params) => getAction(`${PLUGIN_API_PREFIX}/mall/materials`, params)

// 商城商品分类（与 materials 同 scope 口径）
export const getMallCategories = (params) => getAction(`${PLUGIN_API_PREFIX}/mall/categories`, params)

// B2B 入口：已绑定伙伴租户列表
export const getMallSuppliers = () => getAction(`${PLUGIN_API_PREFIX}/mall/suppliers`)

// 商城统一下单 {mode(qgd/cgdd/b2b), supplierId, partnerTenantId, items:[{materialId, operNumber, unitPrice, remark}]}
export const createMallOrder = (data) => postAction(`${PLUGIN_API_PREFIX}/mall/orders`, data)
